// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__GridFocusAnnouncer__gridFocusAnnouncer__gA2oGj{opacity:0;pointer-events:none;position:absolute}", "",{"version":3,"sources":["webpack://./../../platform/@jutro/components/components/fields/date/internal/GridFocusAnnouncer/GridFocusAnnouncer.module.css"],"names":[],"mappings":"AAAA,qDAEE,SAAA,CADA,mBAAA,CAEA,iBAAA","sourcesContent":[".gridFocusAnnouncer {\n  pointer-events: none;\n  opacity: 0;\n  position: absolute;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridFocusAnnouncer": "jut__GridFocusAnnouncer__gridFocusAnnouncer__gA2oGj"
};
export default ___CSS_LOADER_EXPORT___;
